import { hsaFlowValidationErrorSchema } from "@redotech/redo-conversion-hsa-common/hsa-flow-validate";
import { hsaQuestionnaireStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

/**
 * Saves the edited questionnaire as a new immutable flow version and makes
 * it the team's active flow. Beta: the handler 404s for non-Redo-employees.
 */
export const saveHsaQuestionnaireFlow = {
  name: "saveHsaQuestionnaireFlow" as const,
  input: z.object({
    steps: hsaQuestionnaireStepArraySchema,
    /** Defaults to the active flow's name when omitted. */
    name: z.string().min(1).optional(),
  }),
  output: z.union([
    z.object({ ok: z.literal(true), flowId: z.string() }),
    /** Semantic validation failed; nothing was written. */
    z.object({
      ok: z.literal(false),
      errors: z.array(hsaFlowValidationErrorSchema),
    }),
  ]),
};
